import { useContext, useMemo } from 'react';
import AppContext from '../context/AppContext';
import { aggregateReportData } from '../utils/aggregateReportData';

export function useRawReportData() {
  const { sales, leads, activities, appointments, userData } = useContext(AppContext);
  return useMemo(
    () => aggregateReportData({ sales, leads, activities, appointments, userData }),
    [sales, leads, activities, appointments, userData]
  );
}
